export type WindowWithDatalayer = {
  dataLayer: {
    push: (args: dataLayerObject) => void
  }
}

export const hasDatalayer = (w: any): w is WindowWithDatalayer => w['dataLayer'] != undefined

export const pushDataLayer = (d: dataLayerObject) => {
  if (hasDatalayer(window)) {
    window.dataLayer.push(d)
  } else {
    console.log("No dataLayer variable present to push ", d)
  }
}

export type dataLayerObject = {
  event: string
  category: string
  action?: string
  label?: string
}

export const pushDNBDataLayer = (data: { category: string; action: string; label: string }) =>
  pushDataLayer({ ...data, event: 'dnb-event' })
 
export const pushLocationEvent = (d: {[key: string]: string} ) => 
  pushDataLayer({ event: 'dnb-event', category: 'Location', ...d})

export const pushExpand = (label: string) => 
  pushDNBDataLayer({category: 'Location', action: 'Unfold', label: label})

export const pushTag = (label: string) => 
  pushDNBDataLayer({category: 'Activity tag', action: window.location.pathname, label: label})

export const pushReactionAction = (category: string) => (title: string) => (action: string) => pushDNBDataLayer({ category, action, label: title})

export const pushBlogReactionAction = pushReactionAction('Blog')

export const pushTranslateAction = (label: string) =>
  pushDNBDataLayer({ category: `Translate`, action: `change_language`, label: label })
